if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return function () {
      const ctx = this;
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }
}
/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
 constructor() {
  super();
  this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

  this.debouncedOnSubmit = debounce((event) => {
    this.onSubmitHandler(event);
  }, 500);

  this.form = this.querySelector('form');

  if (this.form) {
    // Only submit when Apply button or form submit is triggered
    this.form.addEventListener('submit', (event) => this.onSubmitHandler(event));
  }

  // Mobile Apply button
  this.querySelectorAll('.mobile-filters-apply').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.form?.requestSubmit) {
        this.form.requestSubmit();
      } else if (this.form) {
        this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  });

  // Handle sort changes on desktop
  const sortSelect = this.querySelector('#SortByBar');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      if (e.isTrusted) {
        if (this.form?.requestSubmit) {
          this.form.requestSubmit();
        } else if (this.form) {
          this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    });
  }
}

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.resortProductsByDisplayedPrice();

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.resortProductsByDisplayedPrice();

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  /**
   * Re-sorts product cards in the grid based on their in-stock variant price
   * (via data-instock-price attribute set in Liquid). Also applies client-side
   * pagination when price sort loads extra products into the DOM.
   */
  static resortProductsByDisplayedPrice() {
    // Determine current sort value
    const sortSelect = document.getElementById('SortByBar') || document.getElementById('SortByMobile');
    if (!sortSelect) return;

    const sortValue = sortSelect.value;
    if (sortValue !== 'price-ascending' && sortValue !== 'price-descending') return;

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const allItems = Array.from(grid.children);
    if (allItems.length < 2) return;

    // Separate promotion columns and non-products (blog posts/articles) from product columns
    const promotions = [];
    const nonProducts = [];
    const products = [];

    allItems.forEach((item, index) => {
      if (item.classList.contains('promotion-column')) {
        promotions.push({ element: item, originalIndex: index });
      } else if (item.querySelector('.blog-post') || item.classList.contains('blog-column')) {
        nonProducts.push(item);
      } else {
        products.push(item);
      }
    });

    if (products.length < 2 && nonProducts.length === 0) return;

    // Get in-stock price — prefer data attribute, fallback to displayed text
    const getPrice = (li) => {
      if (li.dataset.instockPrice) {
        const p = parseFloat(li.dataset.instockPrice);
        if (Number.isFinite(p)) return p;
      }
      const amountEl = li.querySelector('.price ins .amount') || li.querySelector('.price .amount');
      if (!amountEl) return sortValue === 'price-ascending' ? Infinity : -Infinity;
      const numeric = amountEl.textContent.replace(/[^0-9.]/g, '');
      const price = parseFloat(numeric);
      return Number.isFinite(price) ? price : (sortValue === 'price-ascending' ? Infinity : -Infinity);
    };

    // Sort product items by in-stock price
    products.sort((a, b) => {
      const priceA = getPrice(a);
      const priceB = getPrice(b);
      return sortValue === 'price-ascending' ? priceA - priceB : priceB - priceA;
    });

    // Re-insert sorted products, preserving promotion positions
    const totalSlots = promotions.length + products.length;
    let prodIdx = 0;

    for (let i = 0; i < totalSlots; i++) {
      const promo = promotions.find(p => p.originalIndex === i);
      if (promo) {
        grid.appendChild(promo.element);
      } else if (prodIdx < products.length) {
        grid.appendChild(products[prodIdx++]);
      }
    }
    while (prodIdx < products.length) {
      grid.appendChild(products[prodIdx++]);
    }
    // Append non-products (blog posts/articles) at the end of the price-sorted products
    nonProducts.forEach(item => grid.appendChild(item));

    // Combine all sorted items for client-side pagination
    const allDisplayItems = [...products, ...nonProducts];

    // --- Client-side pagination ---
    const perPage = parseInt(grid.dataset.productsPerPage) || 12;
    if (allDisplayItems.length <= perPage) return; // All fit on one visual page

    // Hide any existing Shopify pagination (should already be hidden since paginate.pages=1)
    const container = grid.closest('#ProductGridContainer') || grid.parentElement;
    if (container) {
      container.querySelectorAll('pagination-theme, js-pagination, .pagination:not(.price-sort-pagination)').forEach(el => {
        if (!el.classList.contains('price-sort-pagination')) el.style.display = 'none';
      });
    }

    const triggerLazyImages = (item) => {
      const lazyImages = item.querySelectorAll('img[loading="lazy"], img.lazyload');
      lazyImages.forEach(img => {
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      });
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.checkElems();
      }
    };

    // Show only the first page of products
    allDisplayItems.forEach((item, index) => {
      if (index < perPage) {
        item.style.display = '';
        triggerLazyImages(item);
      } else {
        item.style.display = 'none';
      }
    });

    // Remove any existing price-sort pagination
    const oldPag = container?.querySelector('.price-sort-pagination');
    if (oldPag) oldPag.remove();

    // Create pagination element
    const pagEl = document.createElement('div');
    pagEl.className = 'pagination pagination-type--paginated price-sort-pagination';
    grid.after(pagEl);

    const totalPages = Math.ceil(allDisplayItems.length / perPage);
    let currentPage = 1;

    const prevArrowSVG = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 4H6H1M1 4L4.28467 1M1 4L4.28467 7" stroke="var(--color-accent)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const nextArrowSVG = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4H6H11M11 4L7.71533 1M11 4L7.71533 7" stroke="var(--color-accent)" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const showSortedPage = (page) => {
      currentPage = page;
      const start = (page - 1) * perPage;
      const end = start + perPage;
      allDisplayItems.forEach((item, index) => {
        if (index >= start && index < end) {
          item.style.display = '';
          triggerLazyImages(item);
        } else {
          item.style.display = 'none';
        }
      });
      buildControls();

      const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
      const top = grid.getBoundingClientRect().top + document.documentElement.scrollTop - headerH - 30;
      window.scrollTo({ top, behavior: 'smooth' });
    };

    const buildControls = () => {
      if (totalPages <= 1) {
        pagEl.innerHTML = '';
        return;
      }

      let html = '<div class="row"><div class="small-12 columns"><div class="page-numbers nav-links">';

      if (currentPage > 1) {
        html += '<span class="prev"><a href="#product-grid" data-pspage="' + (currentPage - 1) + '">' + prevArrowSVG + '</a></span>';
      }

      const range = 2;
      for (let i = 1; i <= totalPages; i++) {
        if (i === 1 || i === totalPages || (i >= currentPage - range && i <= currentPage + range)) {
          if (i === currentPage) {
            html += '<span class="current">' + i + '</span>';
          } else {
            html += '<span class="page"><a href="#product-grid" data-pspage="' + i + '">' + i + '</a></span>';
          }
        } else if (i === currentPage - range - 1 || i === currentPage + range + 1) {
          html += '<span class="deco">&hellip;</span>';
        }
      }

      if (currentPage < totalPages) {
        html += '<span class="next"><a href="#product-grid" data-pspage="' + (currentPage + 1) + '">' + nextArrowSVG + '</a></span>';
      }

      html += '</div></div></div>';
      pagEl.innerHTML = html;

      pagEl.querySelectorAll('a[data-pspage]').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          showSortedPage(parseInt(link.dataset.pspage));
        });
      });
    };

    buildControls();
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Sync mobile sort dropdown with the fetched server value
    const parsedSortMobile = parsedHTML.querySelector('#SortByMobile');
    const activeSortMobile = document.querySelector('#SortByMobile');
    if (parsedSortMobile && activeSortMobile && activeSortMobile.value !== parsedSortMobile.value) {
      activeSortMobile.value = parsedSortMobile.value;
      activeSortMobile.dispatchEvent(new Event('change', { bubbles: true }));
    }

    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

 static renderActiveFacets(html) {
  const activeFacets = html.querySelector('.active-facets');
  const target = document.querySelector('.active-facets');

  if (activeFacets && target) {
    target.innerHTML = activeFacets.innerHTML;
  }

  FacetFiltersForm.toggleActiveFacets(false);
}

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    if (event) event.preventDefault();

    const formEl = event?.target?.closest('form') || this.form || this.querySelector('form');
    if (!formEl) return;

    const formData = new FormData(formEl);
    const searchParams = new URLSearchParams(formData);

    // Clean up price params if they're still at defaults
    const slider = formEl.querySelector('.price_slider');
    if (slider) {
      const defaultMin = parseFloat(slider.dataset.min) || 0;
      const defaultMax = parseFloat(slider.dataset.max);

      const toNumber = (val) => {
        if (val === null || val === undefined) return null;
        const cleaned = String(val).replace(/,/g, '').trim();
        if (cleaned === '') return null;
        const parsed = parseFloat(cleaned);
        return Number.isFinite(parsed) ? parsed : null;
      };

      const gteVal = toNumber(searchParams.get('filter.v.price.gte'));
      const lteVal = toNumber(searchParams.get('filter.v.price.lte'));

      // If values match defaults, strip them out
      if ((gteVal === null || gteVal === defaultMin) &&
          (lteVal === null || lteVal === defaultMax)) {
        searchParams.delete('filter.v.price.gte');
        searchParams.delete('filter.v.price.lte');
      }
    }

    FacetFiltersForm.renderPage(searchParams.toString(), event);

    // Close mobile drawer after applying
    const facetDrawer = document.getElementById('Facet-Drawer');
    if (facetDrawer && facetDrawer.classList.contains('active')) {
      facetDrawer.classList.remove('active');
      document.body.classList.remove('open-cc');
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      minInput = amounts.querySelector('.field__input_min'),
      maxInput = amounts.querySelector('.field__input_max'),
      args = {
        start: [
          parseFloat(slider.dataset.minValue || 0),
          parseFloat(slider.dataset.maxValue || slider.dataset.max)
        ],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': parseFloat(slider.dataset.min) || 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    // Track whether the user has actually interacted with the slider
    let userHasInteracted = false;

    // Determine if the slider was initialized with non-default values
    // (i.e., price filters already active from URL params)
    const defaultMin = parseFloat(slider.dataset.min) || 0;
    const defaultMax = parseFloat(slider.dataset.max);
    const initialMin = parseFloat(slider.dataset.minValue || 0);
    const initialMax = parseFloat(slider.dataset.maxValue || slider.dataset.max);
    const hasActiveFilter = (initialMin !== defaultMin) || (initialMax !== defaultMax);

    // If there's an active filter from URL, mark as interacted
    if (hasActiveFilter) {
      userHasInteracted = true;
    }

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      // Always update the displayed values for visual feedback
      minInput.value = values[0];
      maxInput.value = values[1];

      // Only set the name attributes (so they submit) if the user
      // has interacted OR if there's already an active price filter
      if (userHasInteracted) {
        minInput.setAttribute('name', 'filter.v.price.gte');
        maxInput.setAttribute('name', 'filter.v.price.lte');
      } else {
        // Remove name so these inputs don't submit with the form
        minInput.removeAttribute('name');
        maxInput.removeAttribute('name');
      }
    });

    // 'start' fires when user begins dragging
    slider.noUiSlider.on('start', function () {
      userHasInteracted = true;
      minInput.setAttribute('name', 'filter.v.price.gte');
      maxInput.setAttribute('name', 'filter.v.price.lte');
    });

    slider.noUiSlider.on('change', function (values) {
      userHasInteracted = true;
      minInput.setAttribute('name', 'filter.v.price.gte');
      maxInput.setAttribute('name', 'filter.v.price.lte');
      form.querySelector('form').dispatchEvent(event);
    });

    // Also handle manual text input in the price fields
    [minInput, maxInput].forEach((input) => {
      input.addEventListener('input', () => {
        userHasInteracted = true;
        minInput.setAttribute('name', 'filter.v.price.gte');
        maxInput.setAttribute('name', 'filter.v.price.lte');
      });

      input.addEventListener('change', () => {
        userHasInteracted = true;
        minInput.setAttribute('name', 'filter.v.price.gte');
        maxInput.setAttribute('name', 'filter.v.price.lte');
        
        // Update the slider to match the manual input
        const minVal = parseFloat(minInput.value) || defaultMin;
        const maxVal = parseFloat(maxInput.value) || defaultMax;
        slider.noUiSlider.set([minVal, maxVal]);
      });
    });

    // Initially remove name attributes if no active filter
    if (!hasActiveFilter) {
      minInput.removeAttribute('name');
      maxInput.removeAttribute('name');
    }
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
  // Re-sort products on initial page load if price sorting is active
  if (typeof FacetFiltersForm !== 'undefined') {
    FacetFiltersForm.resortProductsByDisplayedPrice();
  }
});

// Mobile Apply buttons live outside facet-filters-form; submit the mobile form when clicked
document.addEventListener('click', (event) => {
  const applyBtn = event.target.closest('.mobile-filters-apply');
  if (!applyBtn) return;

  event.preventDefault();
  const mobileForm = document.getElementById('FacetFiltersFormMobile');
  if (mobileForm) {
    if (typeof mobileForm.requestSubmit === 'function') {
      mobileForm.requestSubmit();
    } else {
      mobileForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  const facetDrawer = document.getElementById('Facet-Drawer');
  if (facetDrawer && facetDrawer.classList.contains('active')) {
    facetDrawer.classList.remove('active');
    document.body.classList.remove('open-cc');
  }
});

// Sync both Sort By dropdowns in real-time
document.addEventListener('change', (e) => {
  if (e.target.classList.contains('facet-filters__sort')) {
    const newValue = e.target.value;
    document.querySelectorAll('.facet-filters__sort').forEach((select) => {
      if (select !== e.target && select.value !== newValue) {
        select.value = newValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
});